'use strict';

// We pollute jquery into the global namespace... not that it's not normally local.
window.$ = require('jquery');

var MathDeck = require('./deck')($);
// We pollute the global namespace again such that a skin can modify the game even further.
window.md = new MathDeck(gameOpts);
